var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:_vm.source.selected?_vm.context:'table-light text-muted',on:{"click":_vm.clicked}},[_c('td',[_vm._v(_vm._s(_vm.source.name))]),_c('td',[_vm._v(_vm._s(_vm.risk))]),_c('td',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.reason))])])}
var staticRenderFns = []

export { render, staticRenderFns }